import { render } from "./Decor.vue?vue&type=template&id=4b52c890&scoped=true"
import script from "./Decor.vue?vue&type=script&lang=js"
export * from "./Decor.vue?vue&type=script&lang=js"

import "./Decor.vue?vue&type=style&index=0&id=4b52c890&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b52c890"]])

export default __exports__